<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpNavMenuMainCategories from '~/components/cp/CpNavMenu/CpNavMenuMainCategories/CpNavMenuMainCategories.vue';
  import CpNavMenuCategories from '~/components/cp/CpNavMenu/CpNavMenuCategories/CpNavMenuCategories.vue';
  import CpNavMenuSpecialLinks from '~/components/cp/CpNavMenu/CpNavMenuSpecialLinks/CpNavMenuSpecialLinks.vue';

  const {b, e} = useCpBem('cp-main-nav-menu');
</script>

<template>
    <div :class="b">
        <CpNavMenuSpecialLinks />
        <div :class="e('container')">
            <CpNavMenuMainCategories />
            <CpNavMenuCategories />
        </div>
    </div>
</template>

<style scoped lang="scss">
  .cp-main-nav-menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__container {
      display: flex;
      align-items: flex-start;
      min-height: 100px;
    }
  }
</style>
